import {IonIcon, IonActionSheet, IonSelect, IonSelectOption } from '@ionic/react';
import React, { useState, useEffect } from 'react';
import { language as languageIcon } from 'ionicons/icons'
import prefs, { Language } from '@/controllers/preferences'

const LanguageSelector: React.FC = () => {
  const [language, setLanguage] = useState<Language>('English');

  useEffect(() => {
    const later = async () => {
        setLanguage(await prefs.get_language())
    }
    later()
  })

  return (<>
    <IonSelect value={language} interface="popover" onIonChange={(e) => {
        setLanguage(e.detail.value)
        prefs.set_language(e.detail.value)
    }}>
        <IonIcon icon={languageIcon} style={{ fontSize: '1.5rem', color: 'inherit' }} slot="label" />
        {Object.keys(prefs.languages).map(lang => (
        <IonSelectOption key={lang} value={lang}>{lang}</IonSelectOption>
        ))}
    </IonSelect>
        
    </>);
};

export default LanguageSelector;
